/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_Place_GymInputs */

const en_us2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At a gym`)
};

const pt_br2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na academia`)
};

const es_419_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el gimnasio`)
};

const pt_pt2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ginásio`)
};

const fr_fr2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En salle de sport`)
};

const de_de2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Studio`)
};

const it_it2_onboarding_equipment_place_gym = /** @type {(inputs: Onboarding_Equipment_Place_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In palestra`)
};

/**
* | output |
* | --- |
* | "At a gym" |
*
* @param {Onboarding_Equipment_Place_GymInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_place_gym = /** @type {((inputs?: Onboarding_Equipment_Place_GymInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_Place_GymInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_place_gym(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_place_gym(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_place_gym(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_place_gym(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_place_gym(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_place_gym(inputs)
	return en_us2_onboarding_equipment_place_gym(inputs)
});
export { onboarding_equipment_place_gym as "onboarding.equipment_place.gym" }